<template>
	<AppScreen class="ending-view" :scrollable="false">
		<Video :src="video" @ended="advance" :muted="$store.state.sound.muted" />
	</AppScreen>
</template>

<script>
import AppScreen from '@/components/partials/AppScreen';
import Video from '@/components/base/Video';

export default {
	name: 'EndGameVideo',
	components: {
		AppScreen,
		Video,
	},
	props: {
		video: {
			type: String,
			required: true,
		},
	},
	methods: {
		advance() {
			this.$router.push('/postgame');
		},
	},
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/EndGameVideo.vue